import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router";

import { Pages } from "../Constants/pages";
import {SplashSscreen} from "../Components/SplashSscreen/SplashSscreen";

const Layout = React.lazy(() => import("../Components/Layout/Layout"));
const ProfileLayout = React.lazy(() => import("../Components/Layout/ProfileLayout"));

const Services = React.lazy(() => import("../Pages/Services/Services"));
const ValidationForm = React.lazy(() => import("../Pages/SubmitProccess/ValidationForm/ValidationForm"));
const FinalAnalysisTest = React.lazy(() => import("../Pages/SubmitProccess/FinalAnalysisTest/FinalAnalysisTest"));
const AdditionalInformation = React.lazy(() => import("../Pages/SubmitProccess/AdditionalInformation/AdditionalInformation"));
const ServiceSegments = React.lazy(() => import("../Pages/SubmitProccess/ServiceSegments/ServiceSegments"));
const Result = React.lazy(() => import("../Pages/Result/Result"));
const HomePage = React.lazy(() => import("../Pages/HomePage/HomePage"));
const SpecialistProfile = React.lazy(() => import("../Pages/Specialist/SpecialistProfile/SpecialistProfile"));
const TransactionResult = React.lazy(() => import("../Pages/TransactionResult/TransactionResult"));
const Subscription = React.lazy(() => import("../Pages/Subscription/Subscription"));
const History = React.lazy(() => import("../Pages/History/History"));
const ResultAI = React.lazy(() => import("../Pages/ResultAI/ResultAI"));
const Profile = React.lazy(() => import("../Pages/Profile/Profile"));
const Transactions = React.lazy(() => import("../Pages/Transactions/Transactions"));
const Notifications = React.lazy(() => import("../Pages/Notifications/Notifications"));
const Portfolio = React.lazy(() => import("../Pages/Portfolio/Portfolio"));
const NotFound = React.lazy(() => import("../Pages/NotFound/NotFound"));
const TokenUsageDetails = React.lazy(() => import("../Pages/TokenUsageDetails/TokenUsageDetails"));
const TokenHistoryDetails = React.lazy(() => import("../Pages/TokenHistoryDetails/TokenHistoryDetails"));
const TermsAndRegulations = React.lazy(() => import("../Pages/TermsAndRegulations/TermsAndRegulations"));
const ContactUs = React.lazy(() => import("../Pages/ContactUs/ContactUs"));
const Guide = React.lazy(() => import("../Pages/Guide/Guide"));
const Agencies = React.lazy(() => import("../Pages/Agencies/Agencies"));
const AgencyCreate = React.lazy(() => import("../Pages/AgencyCreate/AgencyCreate"));
const AgencyDataList = React.lazy(() => import("../Pages/AgencyDataList/AgencyDataList"));
const AgencyDataCreate = React.lazy(() => import("../Pages/AgencyDataCreate/AgencyDataCreate"));
const Bots = React.lazy(() => import("../Pages/Bots/bots"));
const Share = React.lazy(() => import("../Pages/Share/Share"));

const createLanguageRoutes = (element: React.ReactElement, path: string) => [
    <Route key={`${path}-default`} element={element} path={path} />,
    <Route key={`${path}-lang`} element={element} path={`/:language${path}`} />,
];

export const Router: React.FC = () => {
    return (
      <BrowserRouter>
        <Suspense fallback={<SplashSscreen />}>
          <Routes>
            {/* Layout Routes */}
            <Route element={<Layout />}>
              {createLanguageRoutes(<Services />, Pages.Services)}
              {createLanguageRoutes(<ValidationForm />, Pages.ValidationForm)}
              {createLanguageRoutes(<FinalAnalysisTest />, Pages.FinalAnalysisTest)}
              {createLanguageRoutes(<AdditionalInformation />, Pages.AdditionalInformation)}
              {createLanguageRoutes(<ServiceSegments />, Pages.ServiceSegments)}
              {createLanguageRoutes(<Share />, Pages.Share)}
              {createLanguageRoutes(<SpecialistProfile />, Pages.SpecialistProfile)}
              {createLanguageRoutes(<TransactionResult />, Pages.TransactionResult)}
              {createLanguageRoutes(<Subscription />, Pages.Subscription)}
              {createLanguageRoutes(<TokenUsageDetails />, Pages.TokenUsageDetails)}
              {createLanguageRoutes(<TermsAndRegulations />, Pages.TermsAndRegulations)}
              {createLanguageRoutes(<ContactUs />, Pages.ContactUs)}
              {createLanguageRoutes(<Guide />, Pages.Guide)}
              {createLanguageRoutes(<Portfolio />, Pages.Portfolio)}
            </Route>

            {/* Profile Layout Routes */}
            <Route element={<ProfileLayout />}>
              {createLanguageRoutes(<Profile />, Pages.Profile)}
              {createLanguageRoutes(<Transactions />, Pages.Transactions)}
              {createLanguageRoutes(<History />, Pages.History)}
              {createLanguageRoutes(<Notifications />, Pages.Notifications)}
              {createLanguageRoutes(<TokenHistoryDetails />, Pages.TokenHistoryDetails)}
            </Route>

            {/* Home Routes */}
            <Route element={<HomePage />} path="/" />
            <Route element={<HomePage />} path="/en" />
            <Route element={<HomePage />} path="/fa" />

            {/* Standalone Routes */}
            {createLanguageRoutes(<ResultAI />, Pages.ResultAI)}
            {createLanguageRoutes(<ResultAI />, Pages.ResultAgency)}
            {createLanguageRoutes(<Result />, Pages.Result)}
            {createLanguageRoutes(<Agencies />, Pages.Agencies)}
            {createLanguageRoutes(<AgencyCreate />, Pages.AgencyCreate)}
            {createLanguageRoutes(<AgencyCreate />, Pages.AgencyEdit)}
            {createLanguageRoutes(<AgencyDataList />, Pages.AgencyDataList)}
            {createLanguageRoutes(<AgencyDataCreate />, Pages.AgencyDataCreate)}
            {createLanguageRoutes(<Bots />, Pages.Agency)}
            <Route element={<NotFound />} path="*" />
          </Routes>
        </Suspense>
      </BrowserRouter>
    );
};
